export default __webpack_public_path__ + "static/philrx-access-solution-73e744905fb2909c7aaae413f706c12c.jpg";